import axios from '@/lib/axios'
/**
 * @type {import('vuex').Module}
 */
export const user = {
  namespaced: true,
  state: {
    profile: null
  },
  mutations: {
    setup(state, user){
      if(!user){
        throw new Error('缺少必要參數')
      }
      state.profile = user
    },
    clear(state){
      state.profile = null
    }
  },
  actions: {
    // 同步登入狀態：
    // 若已登入則將登入資訊存至 profile
    // 若未登入則將 profile 清空(= null)
    async sync(state){
      try{
        let res = await axios.get('/wordprison/user')
        let data = res.data
        state.commit('setup', data.payload.user)
      }catch(e){
        state.commit('clear')
        if(e.response){
          console.log(e.response)
          let data = e.response.data
          if(data.code !== 1){
            console.warn('store: user/sync ', data.message)
          }
        }else{
          console.log(e)
        }
      }
    }
  }
}
